import React, {useEffect, useRef} from "react";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";

import styles from './CallToAction.module.scss';
import ArrowBg from "../../../components/arrow-bg/ArrowBg";
import {useWindowWidth} from "../../../services/useWindowWidth";
import {VEDMARKET_LINKS} from '../../../constants';

function CallToAction() {

    const parallaxRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleScrollCallToAction = () => {
            if (parallaxRef.current) {
                const scrolled = window.scrollY;
                parallaxRef.current.style.transform = `translateY(${scrolled * 0.5}px)`;
            }
        };
        window.addEventListener('scroll', handleScrollCallToAction);
        return () => window.removeEventListener('scroll', handleScrollCallToAction);
    }, []);

    const width = useWindowWidth();

    return (
        <ArrowBg bgImageStyles={{
            bottom: width >= 768 ? '-112%' : 'auto',
            top: width >= 768 ? 'auto' : '0',
            left: width >= 768 ? '-9.7%' : 'auto',
        }}>
            <div className={styles.callToAction} id="callToAction">
                <Container className={styles.callToActionContainer}>
                    <Row className='justify-content-center'>
                        <Col xxl={10}>
                            <h2 className={styles.title}>
                                Станьте одним из первых,
                                кто попробует сервис в&nbsp;действии
                            </h2>
                            <h3 className={styles.subtitle}>
                                Оставьте свои контакты и&nbsp;как только мы&nbsp;начнем тестирование,
                                вы&nbsp;получите доступ одним из&nbsp;первых.
                            </h3>
                            <ButtonPrimary href={VEDMARKET_LINKS.demo} target="_blank" rel="noreferrer" label="Посмотреть демо" isWide className={styles.button}/>
                        </Col>
                    </Row>
                </Container>
            </div>
        </ArrowBg>
    );
}

export default CallToAction;
